import React, { useState, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark } from '@fortawesome/free-regular-svg-icons'
import { AsyncWrapper, Button } from '/src/components/common'
import { Loading } from '/src/components/loading'
import { useUser, useProductFavourite } from '/src/hooks'

import './product_favourite.scss'

export const ProductFavourite = (props) => {
  return <AsyncWrapper>
    <ProductFavouriteDataWrapper {...props} />
  </AsyncWrapper>
}

const ProductFavouriteDataWrapper = (props) => {
  const user = useUser()

  if (!user) {
    return <></>
  }

  return <ProductFavouriteElement {...props} />
}

const getProductAttributes = (attributes) => {
  const results = []

  for (let [key, value] of Object.entries(attributes)) {
    if (key.startsWith('attribute_') && value && value.name) {
      results.push({
        name: key,
        value: value.name
      })
    }
  }

  return results
}

const ProductFavouriteElement = ({
  id,
  drupal_id,
  product_id,
  title,
  field_prod_variation_reference,
  weight,
  relationships,
  internal
}) => {
  const [favourites, setFavourites] = useProductFavourite()
  const [message, setMessage] = useState('Favourite')
  const isLoading = useMemo(() => {
    if (message === 'Added to favourites' || message === 'Removed from favourites') return true
    return false
  }, [message])
  const isDisabled = useMemo(() => {
    if (isLoading || !id) return false
    return true
  }, [isLoading, id])

  const hasFavourite = useMemo(() => {
    return favourites.some(value => value.id === id)
  }, [favourites, id])

  const attributes = useMemo(() => {
    if (!relationships) return []
    return getProductAttributes(relationships)
  }, [relationships])

  const buttonClasses = [
    'button',
    'button-favourite',
    'mb-2'
  ]
  if (hasFavourite) {
    buttonClasses.push('is-favourite')
  }

  const onClickHandler = () => {
    setMessage(hasFavourite ? 'Removed from favourites' : 'Added to favourites')

    setFavourites(values => {
      if (hasFavourite) {
        return values.filter(value => value.id !== id)
      }

      return [...values, {
        id: id, 
        drupal_id: drupal_id,
        product_id: product_id,
        title: title,
        reference: field_prod_variation_reference,
        weight: weight,
        attributes: attributes,
        type: internal.type
      }]
    })

    setTimeout(() => {
      setMessage('Favourite')
    }, 3000)
  }

  return <Button 
    variant="outline" 
    className={buttonClasses.join(' ')}
    name="favourite"
    onClick={onClickHandler}
    disabled={isDisabled ? false : true}>
    <FontAwesomeIcon icon={faBookmark} />
    {message}
  </Button>
}